import styled from "styled-components";

interface ContainerProps {
    $status: 'uploading' | 'success' | 'error';
}

export const Container = styled.div<ContainerProps>`
    width: 100%;
    display: grid;
    grid-template-columns: 25px 1fr auto;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.3);
    gap: 5px;
    border-radius: 6px;
    padding: 15px;
    background-color: ${({ theme, $status }) => {
        if ($status === 'error') return theme.colors.primaryRed50 || 'rgba(239, 68, 68, 0.05)';
        return 'transparent';
    }};
    transition: background-color 0.3s ease;

    @container anexos-list (max-width: 800px){
        align-items: flex-start
    }

    .icone {
        > svg {
            width: 18px;
            height: 18px;
            @container anexos-list (max-width: 800px) {
                width: 22px;
                height: 25px;
            }
        }
    }

    .meio {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 8px;
        
        .top {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 10px;

            @container anexos-list (max-width: 800px) {
                flex-direction: column;
                align-items: flex-start;
                gap: 5px;
            }
            
            .nome {
                font-size: 13px;
                color: ${({ theme }) => theme.colors.c000000};
                font-weight: 600;
                max-width: 300px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-break: break-word;
            }
            
            .extensao {
                background-color: ${(props: any) => props.theme.colors.interfacePure0};
                color: ${(props: any) => props.theme.colors.c374151};
                padding: 3px 8px;
                border-radius: 12px;
                box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.3);
                font-size: 10px;
                font-weight: 500;
            }
        }

        .bottom {
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 11px;
            font-weight: 400;
            color: ${({ theme }) => theme.colors.interfaceGray400};
            flex-wrap: wrap;
            gap: 4px;

            @container anexos-list (max-width: 800px) {
                flex-direction: column;
                align-items: flex-start;
                gap: 5px;
                
                > svg {
                    display: none;
                }
                
                > span {
                    word-break: break-word;
                    max-width: 100%;
                }
            }
        }
    }

    .action-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        
        .spinner {
            animation: spin 1s linear infinite;
        }

        .error-buttons {
            display: flex;
            gap: 8px;
            align-items: center;
        }
        
        .retry-button,
        .cancel-button {
            background: none;
            border: none;
            cursor: pointer;
            padding: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: transform 0.2s ease;
            border-radius: 4px;
            
            &:hover {
                transform: scale(1.1);
                background-color: rgba(0, 0, 0, 0.05);
            }
            
            &:active {
                transform: scale(0.95);
            }
        }
        
        @keyframes spin {
            from {
                transform: rotate(0deg);
            }
            to {
                transform: rotate(360deg);
            }
        }
    }
`;

interface ProgressBarProps {
    $progress: number;
}

export const ProgressBar = styled.div<ProgressBarProps>`
    display: flex;
    align-items: center;
    gap: 10px;
    
    .progress-bg {
        flex: 1;
        height: 8px;
        background-color: ${({ theme }) => theme.colors.interfaceGray100 || '#e5e7eb'};
        border-radius: 4px;
        overflow: hidden;
        
        .progress-fill {
            height: 100%;
            width: ${({ $progress }) => $progress}%;
            background-color: ${({ theme }) => theme.colors.primaryRed400 || '#ef4444'};
            transition: width 0.3s ease;
            border-radius: 4px;
        }
    }
    
    .progress-text {
        font-size: 11px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.primaryRed400 || '#ef4444'};
        min-width: 35px;
        text-align: right;
    }
`;

